import React from 'react'

import './Button.scss'

function Button({ children, variant = 'primary', className, onClick }) {
  return (
    <div className={`button button--${variant} ${className}`} onClick={onClick}>
      {children}
    </div>
  )
}

export default Button
